import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { goDownload } from "@/service/utils";
import "./index.less";

const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.62343 0.666017C5.63801 0.666019 5.65264 0.666019 5.66732 0.666019H8.33399V1.99935H5.66732C5.01993 1.99935 4.60146 2.00077 4.29312 2.04222C4.00396 2.0811 3.91333 2.14386 3.86258 2.19461C3.81183 2.24536 3.74907 2.336 3.71019 2.62516C3.66874 2.93349 3.66732 3.35197 3.66732 3.99935V11.9994C3.66732 12.6467 3.66874 13.0652 3.71019 13.3736C3.74907 13.6627 3.81183 13.7533 3.86258 13.8041C3.91333 13.8548 4.00396 13.9176 4.29312 13.9565C4.60146 13.9979 5.01993 13.9994 5.66732 13.9994H8.33399C8.98137 13.9994 9.39985 13.9979 9.70818 13.9565C9.99734 13.9176 10.088 13.8548 10.1387 13.8041C10.1895 13.7533 10.2522 13.6627 10.2911 13.3736C10.3326 13.0652 10.334 12.6467 10.334 11.9994V6.45638H11.6673L11.6673 12.0432C11.6674 12.6342 11.6674 13.1434 11.6126 13.5512C11.5538 13.9882 11.4213 14.4071 11.0815 14.7469C10.7418 15.0867 10.3229 15.2192 9.88585 15.2779C9.47807 15.3328 8.96886 15.3327 8.37786 15.3327H5.62345C5.03245 15.3327 4.52324 15.3328 4.11546 15.2779C3.67845 15.2192 3.25955 15.0867 2.91977 14.7469C2.58 14.4071 2.4475 13.9882 2.38875 13.5512C2.33392 13.1434 2.33395 12.6342 2.33399 12.0432L2.33399 3.99935C2.33399 3.98467 2.33399 3.97004 2.33399 3.95547C2.33395 3.36447 2.33392 2.85527 2.38875 2.44749C2.4475 2.01048 2.58 1.59158 2.91977 1.25181C3.25955 0.912031 3.67845 0.779534 4.11546 0.720779C4.52323 0.665956 5.03244 0.665984 5.62343 0.666017ZM11.6673 3.05654L12.5292 2.19461L13.4721 3.13742L11.4721 5.13742C11.2117 5.39777 10.7896 5.39777 10.5292 5.13742L8.52925 3.13742L9.47206 2.19461L10.334 3.05654V0.666019H11.6673V3.05654ZM7.66732 12.666H6.33399V11.3327H7.66732V12.666Z"
        fill="white"
      />
    </svg>
  );
};

// Mobile device detection
const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i) ? true : false;
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i) ? true : false;
  },
  IOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i) ? true : false;
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.IOS() ||
      isMobile.Windows()
    );
  },
};


const DownloadBtn = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="download-app-mobile--link" onClick={goDownload}>
        <span>{t("Download.btn")}</span>
        <PhoneIcon></PhoneIcon>
      </div>
    </>
  );
};

export default DownloadBtn;
